import React, { useState, useEffect, useCallback } from "react";

// components
// import { ListWrap } from "src/components";
import { EventSlider } from "..";

// api
import { clearCacheCategory, fetchEventByCategoryCache } from "src/api/HomeApi";

// mockup
import mockup from "src/utils/data";

// utils
import { getNextCategories } from "src/utils/helpers";

const NextEvents = ({ currCategory, userLocation, handleClick }) => {
  const [listOne, setListOne] = useState({
    category: {},
    list: mockup.empty_3,
  });
  const [listTwo, setListTwo] = useState({
    category: {},
    list: mockup.empty_3,
  });
  const [listThree, setListThree] = useState({
    category: {},
    list: mockup.empty_3,
  });

  const fetchNextEvents = useCallback(
    async (_category, _callback) => {
      if (currCategory && userLocation) {
        // update only category name
        _callback({ category: _category, list: mockup.empty_3 });

        let params = {
          catgId: _category.data.Categoryid,
          lat: userLocation.latitude,
          lng: userLocation.longitude,
          limit: 16,
        };

        try {
          const response = await fetchEventByCategoryCache(params, false);

          if (response.data.Status) {
            _callback({
              category: _category,
              list: response.data.Results,
            });
          } else {
            const id = `/Event${params.catgId}`;
            clearCacheCategory(id);
            _callback({
              category: _category,
              list: null,
            });
          }
        } catch (err) {
          console.log({ _category, err });
          _callback({
            category: _category,
            list: null,
          });
        }
      }
    },
    [currCategory, userLocation]
  );

  useEffect(() => {
    if (currCategory) {
      let nextCatg = getNextCategories(currCategory, mockup.by_category);

      fetchNextEvents(nextCatg[0], setListOne);
      fetchNextEvents(nextCatg[1], setListTwo);
      fetchNextEvents(nextCatg[2], setListThree);
    }
  }, [fetchNextEvents, currCategory]);

  return (
    <div style={{ marginTop: "2rem" }}>
      <EventSlider
        heading={listOne.category?.data?.CategoryName || ""}
        list={listOne.list}
        to
        limit
        handleClick={() => handleClick(listOne.category?.data)}
      />
      <EventSlider
        heading={listTwo.category?.data?.CategoryName || ""}
        list={listTwo.list}
        to
        limit
        handleClick={() => handleClick(listTwo.category?.data)}
      />
      <EventSlider
        heading={listThree.category?.data?.CategoryName || ""}
        list={listThree.list}
        to
        limit
        handleClick={() => handleClick(listThree.category?.data)}
      />
      {/* <ListWrap
        heading={listOne.category?.data?.CategoryName || ""}
        items={listOne.list}
        to
        limit
        handleClick={() => handleClick(listOne.category?.data)}
      />
      <ListWrap
        heading={listTwo.category?.data?.CategoryName || ""}
        items={listTwo.list}
        to
        limit
        handleClick={() => handleClick(listTwo.category?.data)}
      />
      <ListWrap
        heading={listThree.category?.data?.CategoryName || ""}
        items={listThree.list}
        to
        limit
        handleClick={() => handleClick(listThree.category?.data)}
      /> */}
    </div>
  );
};

export default NextEvents;
